// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"styles_imageContainer__TzGQI","wishlistButton":"styles_wishlistButton__bC4OR","breadcrumbContainer":"styles_breadcrumbContainer__2vfUo"};